const React = require("react");

function SwitchHorizontalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
  }));
}

module.exports = SwitchHorizontalIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SwitchHorizontalIcon.js
 ** module id = 623
 ** module chunks = 0
 **/